var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-text",class:['is-' + _vm.type, { 'is-inline-block': _vm.inline }]},[_c('fa-icon',{staticClass:"info-icon mt-1 ml-1",attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"info-content",class:[{ 'is-inline': _vm.inline }]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }